module.exports = __webpack_public_path__ + "img/esports.95a0e087.svg";